import { getWindowSize } from './window-size-utils';
import { getAndroidVersion, isAndroid } from './environment-utils';

const smartphoneThreshold = 600;

export function getScreenDensity(): number {
  return isAndroid() && getAndroidVersion() < 4.4
    ? window.devicePixelRatio || 1
    : 1;
}

export function checkIsTablet(): boolean {
  const { width, height } = getWindowSize();
  const screenDensity = getScreenDensity();
  return Math.min(width, height) / screenDensity > smartphoneThreshold;
}
